import useGetAuthentication from '@/domains/authentication/useGetAuthentication.ts';
import useAuthNavigator from '@/pages/authentication/navigation/useAuthNavigator.ts';
import dayjs from 'dayjs';
import { useState } from 'react';

const useAuthCard = () => {
  const { handleUserType, userType } = useAuthNavigator();
  const [forgotPasswordContent, setForgotPasswordContent] = useState(false);
  const { data: authenticationData } = useGetAuthentication();
  const currentDate = dayjs().year();

  const toggleContentForgotPassword = () => {
    setForgotPasswordContent((prevState) => !prevState);
  };

  return {
    handleUserType,
    userType,
    forgotPasswordContent,
    currentDate,
    toggleContentForgotPassword,
    authenticationData,
  };
};

export default useAuthCard;
